import React from 'react'
import PropTypes from "prop-types"
import DocumentTitle from "react-document-title"
import { connect } from 'react-redux'
import { Link, browserHistory } from 'react-router'
import { min, values, set, findIndex, without, debounce, omit, clone, isEmpty } from 'lodash'
import Ajax from 'superagent'

import {
  PageHeader, Panel, Form, FormGroup, FormControl, Row, Col,
  ControlLabel, Glyphicon, ButtonGroup, InputGroup
} from 'react-bootstrap'

import RestaurantContent from './MenusPage/RestaurantContent'
import Button from '../components/Button.jsx'
import { PriceEditor } from '../components/Price.jsx'
import MarkdownField from '../lib/MarkdownField.jsx'
import { updateProduct, removeProduct } from '../ducks/products'
import { docPageStyle } from '../containers/PageStyles'
import FilesSelector from '../lib/FilesSelector.jsx'
import { getReadyState, getProductTags } from '../selectors'
import { fetchGeolocation, getGeolocationParameters } from '../lib/AppTools'
import { getText } from '../lib/text.js'
import ModalNameEditor from './ModalNameEditor.jsx'
import checkIfProductIsReady from './ProductsTools.jsx'
import ProductWarning from './Product.Warning.jsx'
import TranslateLink from '../components/TranslateLink'
import { randstr, moveInArray } from '../../lib/Tools'
import TagsList from '../tags/TagsList.jsx'
import { isShopping, isRestaurant } from '../tags/TagsIds.js'
import postResetZSX from "./resetZSX"

import TimeTableEditor from '../timetable/editor/TimeTableEditor'
import TimeTableCalendar from '../timetable/TimeTableCalendar'
import Relations from "./Product.Relations"

import './Product.less'

const WarningSign = () => (
  <Glyphicon glyph="warning-sign" style={{ color: "red", marginLeft: "5px" }} />
)

const styles = {
  fg: { display: "block", padding: 2, marginTop: 10 },
  label: { width: 200 },
  sublabel: { color: "#555", marginBottom: 2, fontSize: 14, fontStyle: "italic" },

  featherIconWrapper: {
    borderRadius: 3,
    height: 30,
    width: 30,
    marginLeft: 10,

    display: "inline-flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignContent: "flex-start",
    alignItems: "center",

    backgroundColor: "rgba(239,150,55,.9)",
    color: "#fff",
    border: "1px solid #fff",
    maxWidth: "80%",
  }
}

const Props =  {
  // from father
  product: PropTypes.object.isRequired,

  // from connect
  ready: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
}

class Product extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { searchedAddress: null, geolocation: null, timetableEditor: true }
    this.dataForGeolocation = {}
    this.debouncedGeolocation = debounce((dataForGeolocation) => {
      this.getGeolocation(dataForGeolocation)
    }, 1000, { trailing : true })
  }

  props: Props

  componentDidUpdate(prevProps) {
    this.checkAdress(prevProps)
  }

  checkAdress(prevProps) {
    if (
      this.props.product.address != prevProps.product.address
      || this.props.product.city != prevProps.product.city
      || this.props.product.name != prevProps.product.name
    ) {
      this.debouncedGeolocation({
        nextAddress : this.props.product.address,
        currentAddress : prevProps.product.address,
        nextCity : this.props.product.city,
        currentCity : prevProps.product.city,
        nextName : this.props.product.name,
        currentName : prevProps.product.name
      })
    }
  }

  postRefreshCatalogo() {
    Ajax.post(`/api/updaterestaurants`)
      .then(res => {
        if (res.status != 200) alert(`Error ${res.catalogoStatus}`)
      })
      .catch(wtf => alert(`Error ${JSON.stringify(wtf)}`))
  }

  getGeolocationText() {
    const g = this.props.product.preciseLocation
    return g ? `${g.address} (${g.longitude}, ${g.latitude})` : "..."
  }

  getGeolocation(dataForGeolocation) {
    if (!dataForGeolocation.nextAddress) {
      this.props.onChange(this.props.product._id, {
        preciseLocation: {
          address: "",
          longitude: null,
          latitude: null,
        }
      })
    }
    else {
      const x = getGeolocationParameters(dataForGeolocation)
      this.setState({ searchedAddress : x })
      if (x) {
        fetchGeolocation(x).then(geolocation => {
          if (x == this.state.searchedAddress) {
            this.props.onChange(this.props.product._id, {
              preciseLocation: {
                address: geolocation.formatted_address,
                longitude: geolocation.geometry.location.lng,
                latitude: geolocation.geometry.location.lat,
              }
            })
          }
        })
      }
    }
  }

  render() {
    const { product, onChange } = this.props
    if (!this.props.ready || !product) return (<p>Loading...</p>)

    else return (
      <div style={docPageStyle({ maxWidth: 1024 })} className="product-div">
        <DocumentTitle title= {`Producto: ${product.name || product.chName || "Producto nuevo"}`} />

        <div className="product-control-sticky">

          <Link to="/private/products" style={{ fontWeight: "bold", fontSize: "15px" }}>
            { `< ${getText("Volver a los productos")}`}
          </Link>
          
          {
            checkIfProductIsReady(product)
              ? (
                <div className="check-ok">
                  ✔️ Listo para aparecer en ZhangShang
                  <Button onClick={postResetZSX} glyph="refresh" label={getText("Refrescar ZXS")} />
                </div>
              )
              : (
                <div className="check-error">
                  ❌ Faltan datos para aparecer en ZhangShang
                </div>
              )
          }

        </div>

        <PageHeader>
          {product.name} <small>{product.title}</small>
          <Link to={`/private/log/products/${product._id}`} style={{ fontSize: "0.7em", marginLeft: 20 }}>
            <Glyphicon glyph="list" /> Ver log
          </Link>
        </PageHeader>

        <Form inline>

          <Row>
            <Col md={7}>
              {/* Información básica */}
              <Panel bsStyle="info" className="bordered-panel">
                <Panel.Heading>
                  <Panel.Title>Información básica</Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <FormGroup style={styles.fg}>
                    <ControlLabel style={styles.label}>
                      {getText("spanish_name")}*:
                    </ControlLabel>
                    <FormControl
                      className= "name-control"
                      type="text"
                      value={product.name}
                      onChange={evt => onChange(product._id, { name: evt.target.value })}
                    />
                    {!product.name && <Glyphicon glyph="warning-sign"  style={{ color: "red", marginLeft: "5px" }}/>}
                  </FormGroup>
                  <FormGroup style={styles.fg}>
                    <ControlLabel style={styles.label}>
                      {getText("chinese_title")}*:
                    </ControlLabel>
                    <FormControl
                      className= "name-control"
                      type="text"
                      value={product.chName}
                      onChange={evt => onChange(product._id, { chName: evt.target.value })}
                    />
                    {!product.chName && <Glyphicon glyph="warning-sign"  style={{ color: "red", marginLeft: "5px" }}/>}
                    <TranslateLink text={product.chName} />
                  </FormGroup>
                  <FormGroup style={styles.fg}>
                    <ControlLabel style={styles.label}>
                      {getText("🇨🇳 Subtítulo")}*:
                    </ControlLabel>
                    <FormControl
                      className= "name-control"
                      type="text"
                      value={product.subtitle}
                      onChange={evt => onChange(product._id, { subtitle: evt.target.value })}
                    />
                    {
                      !product.subtitle && !isRestaurant(product) && (
                        <Glyphicon glyph="warning-sign"  style={{ color: "red", marginLeft: "5px" }}/>
                      )
                    }
                    <TranslateLink text={product.subtitle} />
                  </FormGroup>

                  <FormGroup style={styles.fg}>
                    <ControlLabel style={styles.label}>
                      Rango <small>(recomendado de 0 a 100)</small>:
                    </ControlLabel>
                    <FormControl
                      className= "rank-control"
                      type="number"
                      value={product.rank}
                      onChange={evt => {
                        const rank = min([ 999, parseInt(evt.target.value) || 0 ])
                        onChange(product._id, { rank })
                      }}
                    />
                  </FormGroup>

                  <div>
                    <div><label>Etiquetas:</label></div>
                    <TagsList
                      tagType="products"
                      allTags={this.props.tags}
                      selectedTags={product.tags || {}}
                      onChange={tags => onChange(product._id, { tags })}
                      onClick={tagId => console.log(`nothing to do with clicked tag ${tagId}`)}
                    />
                  </div>

                  <div>
                    <FormGroup>
                      <div style={{ marginTop: 5 }}>
                        <ControlLabel>{getText("🇪🇸/🇨🇳 Otros términos para búsqueda")} <small>(separados por coma)</small>:</ControlLabel>
                      </div>
                      <div margin={{ marginLeft: 15 }}>
                        <FormControl
                          type="text"
                          value={product.extraTerms}
                          style={{ width: 350 }}
                          onChange={evt => onChange(product._id, { extraTerms: evt.target.value })}
                        />
                        <TranslateLink text={product.extraTerms} />
                      </div>
                    </FormGroup>
                  </div>

                  {
                    !isShopping(product) && !isRestaurant(product) && (
                      <Panel style={{ marginTop: 10, marginBottom: 0 }}>
                        <Panel.Heading>Precios</Panel.Heading>
                        <Panel.Body>
                          <PriceEditor
                            price={product.price}
                            onChange={price => onChange(product._id, { price })}
                          />
                        </Panel.Body>
                      </Panel>
                    )
                  }

                  {
                    isRestaurant(product) && (
                      <React.Fragment>
                        <FormGroup style={styles.fg}>
                          <ControlLabel style={styles.label}>
                            {getText("Precio medio por persona")}:
                          </ControlLabel>
                          <InputGroup>
                            <FormControl
                              className= "ppp-control"
                              type="number"
                              value={product.ppp}
                              onChange={evt => onChange(product._id, { ppp: evt.target.value })}
                            />
                            <InputGroup.Addon>€</InputGroup.Addon>
                          </InputGroup>
                        </FormGroup>
                        <FormGroup style={styles.fg}>
                          <ControlLabel style={styles.label}>
                            {getText("Tipo de comida")}:
                          </ControlLabel>
                          <FormControl
                            className= "type-control"
                            type="text"
                            value={product.foodType}
                            onChange={evt => onChange(product._id, { foodType: evt.target.value })}
                          />
                        </FormGroup>
                      </React.Fragment>
                    )
                  }

                  <FormGroup style={{ marginTop: 20 }}>
                    <ControlLabel>
                      {getText("Dirección (completa)")}*:
                    </ControlLabel>
                    <FormControl
                      type="text"
                      style={{ marginLeft: 5, width: 400 }}
                      value={product.address}
                      onChange={evt => onChange(product._id, { address: evt.target.value })}
                    />
                    {!product.address && <Glyphicon glyph="warning-sign"  style={{ color: "red", marginLeft: "5px" }}/>}
                    <div>
                      Geolocation:
                      {this.getGeolocationText()}
                    </div>
                  </FormGroup>

                </Panel.Body>
              </Panel>

            </Col>
            <Col md={5}>
              <Relations 
                relations={product.relations}
                onChange={relations => onChange(product._id, { relations })}
                product={product}
              />
            </Col>
          </Row>

          <Row>
            <Col md={7}>
              <Panel bsStyle="info" className="bordered-panel">
                <Panel.Heading>
                  <Panel.Title>Contenido</Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <FormGroup style={styles.fg}>
                    <MarkdownField
                      onChange={x => onChange(product._id, { description: x })}
                      value={product.description}
                      label={(
                        <div>
                          {getText("🇨🇳 Descripción producto*")}
                          {
                            !product.description && (
                              <Glyphicon glyph="warning-sign"  style={{ color: "red", marginLeft: "5px" }}/>
                            )
                          }
                          <TranslateLink text={product.description} />
                        </div>
                      )}
                    />
                  </FormGroup>
                  <FormGroup style={styles.fg}>
                    <MarkdownField
                      onChange={x => onChange(product._id, { longdescription: x })}
                      value={product.longdescription}
                      label={(
                        <span>
                          {getText("🇨🇳 Descripción detallada producto")}
                          <TranslateLink text={product.longdescription} />
                        </span>
                      )}
                    />
                  </FormGroup>

                  <ProductWarning
                    warning={product.firstWarning}
                    label={<span>{getText("🇨🇳 Aviso")}<TranslateLink text={product.firstWarning.text || ""} /></span>}
                    sublabel="Aparece al principio; se puede usar para ofrecer un paquete o una actividad relacionada."
                    onChange={firstWarning => onChange(product._id, { firstWarning })}
                  />

                  <ProductWarning
                    warning={product.lastWarning}
                    label={<span>{getText("🇨🇳 Aviso al final")}<TranslateLink text={product.lastWarning.text || ""} /></span>}
                    sublabel="Aparece al final; se puede usar para indicar las condiciones."
                    onChange={lastWarning => onChange(product._id, { lastWarning })}
                    style={{ marginTop: 15 }}
                  />

                  <FilesSelector
                    title="Ficheros"
                    allowNew
                    includeNotes
                    extensions={{ foreground: ["jpg", "jpeg", "png"], background: ["jpg", "jpeg", "png"] }}
                    value={{
                      // #NOTE foreground and bg images aren't inside the files object. yea, they really should.
                      ...product.files,
                      foreground: product.foreground.image,
                      background: product.background.image,
                    }}
                    onChange={obj => onChange(product._id, {
                      files: omit(obj, ["foreground", "background"]),
                      // #NOTE foreground and bg images aren't inside the files object. yea, they really should.
                      foreground: { image: obj.foreground },
                      background: { image: obj.background },
                    })}
                    fileNotes={product.fileNotes || {}}
                    onNotesChange={fileNotes => { onChange(product._id, { fileNotes }); }}
                    labels={{
                      foreground: (<span>Imagen principal {!product.foreground.image && <WarningSign />}</span>),
                      background: (<span>Imagen de fondo {!product.background.image && <WarningSign />}</span>),
                    }}
                  />
                </Panel.Body>
              </Panel>
            </Col>
            <Col md={5}>
              <Panel bsStyle="warning" className="bordered-panel">
                <Panel.Heading>
                  <Panel.Title>Información para la reserva</Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <FormGroup style={styles.fg}>
                    <MarkdownField
                      onChange={x => onChange(product._id, { reservationNote: x })}
                      value={product.reservationNote || ""}
                      label={getText("🇪🇸 Nota interna para la reserva")}
                      sublabel="A quién dirigirse, si tienen algo raro en su proceso..."
                    />
                  </FormGroup>
                  <FormGroup style={styles.fg}>
                    <ControlLabel style={{ width: 100 }}>
                      {getText("Teléfono")}:
                    </ControlLabel>
                    <FormControl
                      className= "type-control"
                      type="text"
                      value={product.reservationPhone || ""}
                      onChange={evt => onChange(product._id, { reservationPhone: evt.target.value })}
                    />
                  </FormGroup>
                  <FormGroup style={styles.fg}>
                    <ControlLabel style={{ width: 100 }}>
                      {getText("Mail")}:
                    </ControlLabel>
                    <FormControl
                      className= "type-control"
                      type="text"
                      style={{ width: 350 }}
                      value={product.reservationMail || ""}
                      onChange={evt => onChange(product._id, { reservationMail: evt.target.value })}
                    />
                  </FormGroup>
                </Panel.Body>
              </Panel>
            </Col>
          </Row>

          <Panel className="timetable-panel bordered-panel" bsStyle="info">
            <Panel.Heading>
              <Panel.Title>
              📅 Disponibilidad
                {!(product.timetable && (!isEmpty(product.timetable.schedules) || !isEmpty(product.timetable.exceptions))) && <Glyphicon glyph="warning-sign"  style={{ color: "red", marginLeft: "5px" }}/>}
              </Panel.Title>
              <ButtonGroup>
                <Button
                  glyph="calendar" label="Ver calendario"
                  active={!this.state.timetableEditor}
                  onClick={() => this.setState({ timetableEditor: false })}
                />
                <Button
                  glyph="pencil" label="Editar"
                  active={this.state.timetableEditor}
                  onClick={() => this.setState({ timetableEditor: true })}
                />
              </ButtonGroup>
            </Panel.Heading>
            <Panel.Body>
              {
                this.state.timetableEditor
                  ? (
                    <TimeTableEditor
                      timetable={product.timetable}
                      onChange={timetable => onChange(product._id, { timetable })}
                    />
                  )
                  : (<TimeTableCalendar timetable={product.timetable} />)
              }
            </Panel.Body>
          </Panel>

          {
            isRestaurant(product) && (
              <RestaurantContent
                product={product}
                onChange={change => this.props.onChange(product._id, change)}
              />
            )
          }

          {
            !isShopping(product) && (
              <Panel bsStyle="warning" className="bordered-panel">
                <Panel.Heading>
                  <Panel.Title>Opciones</Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                    {
                      values(product.options).map(option => {
                        const values = clone(option.values)
                        return (
                          <Panel
                            style={{ width: "100%", position: "relative" }}
                            key={option.key}
                          >
                            <Panel.Heading>
                              <div>
                                {`${option.title} (${option.chTitle})`}
                                <Button
                                  style={{ position: "absolute", right: 33 }}
                                  bsSize="xsmall"
                                  glyph="pencil"
                                  tooltipText="Editar opción"
                                  onClick={() => this.setState({ editOptionModal: option })}
                                />
                                <Button
                                  style={{ position: "absolute", right: 5 }}
                                  bsStyle="danger"
                                  bsSize="xsmall"
                                  glyph="trash"
                                  tooltipText="Eliminar opción"
                                  onClick={() => {
                                    if (confirm(`¿Seguro que desea borrar la opción ${option.title} (${option.chTitle})?`)) {
                                      onChange(product._id, { options: omit(product.options, option.key) })
                                    }
                                  }}
                                />
                              </div>
                            </Panel.Heading>
                            <Panel.Body>
                              <ul className="optionul">
                                {
                                  values.map((value, i) => (
                                    <li key={value.key || value} className="optionli">
                                      {value.chvalue}{value.value && `(${value.value})`}
                                      <ButtonGroup className="optionButtons">
                                        <Button
                                          disabled={i == 0}
                                          bsSize="xsmall"
                                          glyph="triangle-top"
                                          onClick={() => onChange(product._id, {
                                            options: set(
                                              product.options,
                                              [option.key, "values"],
                                              moveInArray(values, i, i - 1)
                                            )
                                          })}
                                        />
                                        <Button
                                          disabled={i == values.length - 1}
                                          bsSize="xsmall"
                                          glyph="triangle-bottom"
                                          onClick={() => onChange(product._id, {
                                            options: set(
                                              product.options,
                                              [option.key, "values"],
                                              moveInArray(values, i, i + 1)
                                            )
                                          })}
                                        />
                                        <Button
                                          bsSize="xsmall"
                                          glyph="pencil"
                                          className="optionedit"
                                          onClick={() => this.setState({ editOptionValueModal: { value, option } })}
                                        />
                                        <Button
                                          bsStyle="danger"
                                          bsSize="xsmall"
                                          glyph="remove"
                                          className="optionremove"
                                          onClick={() => onChange(product._id, {
                                            options: set(
                                              product.options,
                                              [option.key, "values"],
                                              without(values, value)
                                            )
                                          })}
                                        />
                                      </ButtonGroup>

                                    </li>
                                  ))
                                }
                              </ul>
                            </Panel.Body>
                            <Panel.Footer>
                              <Button
                                glyph="plus"
                                style={{ marginTop: 5 }}
                                onClick={() => this.setState({ addOptionValueModal: option })
                                }
                              >
                                Añadir valor
                              </Button>
                            </Panel.Footer>
                          </Panel>
                        )
                      })
                    }

                    <Button
                      glyph="plus"
                      onClick={() => this.setState({ addOptionModal: true })}
                      label="Añadir opción"
                    />
                  </div>
                </Panel.Body>
              </Panel>
            )
          }

          <Panel bsStyle="warning" className="bordered-panel">
            <Panel.Heading>
              <Panel.Title>Extras</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              {
                values(product.extras).map(extra => (
                  <Panel key={extra.key}>
                    <Panel.Heading>
                      <Panel.Title style={{ position: "relative" }}>
                        {`${extra.title} (${extra.chTitle})`}
                        <Button
                          style={{ position: "absolute", right: 33 }}
                          bsSize="xsmall"
                          glyph="pencil"
                          onClick={() => this.setState({ editExtraModal: extra })}
                        />
                        <Button
                          bsStyle="danger"
                          style={{ position: "absolute", right: 5 }}
                          bsSize="xsmall"
                          glyph="trash"
                          onClick={() => {
                            if (confirm(`¿Seguro que desea borrar el extra ${extra.title} (${extra.chTitle})?`)) {
                              onChange(product._id, { extras: omit(product.extras, extra.key) })
                            }
                          }}
                        />
                      </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                      <PriceEditor
                        price={extra.price}
                        onChange={price => onChange(product._id, {
                          extras: set(product.extras, [extra.key, "price"], price)
                        })}
                      />
                    </Panel.Body>
                  </Panel>
                ))
              }
              <Button
                glyph="plus"
                onClick={() => this.setState({ addExtraModal: true })}
                label="Añadir extra"
              />
            </Panel.Body>
          </Panel>
        </Form>

        <Button
          glyph="remove"
          onClick={() => {
            if (confirm(`¿Seguro que quieres borrar ${product.name || "Sin nombre"}?`)) {
              this.props.onRemove(product._id)
              browserHistory.push("/private/products")
            }
          }}
          className="btn-danger"
          label="Eliminar producto"
        />

        {
          this.state.addOptionModal && (
            <ModalNameEditor
              headerTitle="Añadir opcion"
              onClose={() => this.setState({ addOptionModal: false })}
              onChange={(title, chTitle) => {
                const key = randstr()
                onChange(product._id, { options: { ...product.options, [key]: { key, title, chTitle, values: [] } } })
                this.setState({ addOptionModal: false })
              }}
            />
          )
        }


        {
          this.state.editOptionModal && (
            <ModalNameEditor
              headerTitle="Editar opcion"
              value={this.state.editOptionModal}
              onClose={() => this.setState({ editOptionModal: false })}
              onChange={(title, chTitle) => {
                onChange(product._id, {
                  options: set(
                    product.options,
                    [this.state.editOptionModal.key],
                    { ...product.options[this.state.editOptionModal.key], title, chTitle }
                  )
                })
                this.setState({ editOptionModal: false })
              }}
            />
          )
        }

        {
          this.state.addOptionValueModal && (
            <ModalNameEditor
              headerTitle="Añadir valor"
              onClose={() => this.setState({ addOptionValueModal: false })}
              onChange={(value, chvalue) => {
                const key = randstr()
                onChange(product._id, {
                  options: set(
                    product.options,
                    [this.state.addOptionValueModal.key, "values"],
                    [...this.state.addOptionValueModal.values || [], { key, value, chvalue }]
                  )
                })
                this.setState({ addOptionValueModal: false })
              }}
            />
          )
        }

        {
          this.state.editOptionValueModal && (
            <ModalNameEditor
              headerTitle="Editar valor"
              value={{
                title: this.state.editOptionValueModal.value.value,
                chTitle: this.state.editOptionValueModal.value.chvalue
              }}
              onClose={() => this.setState({ editOptionValueModal: false })}
              onChange={(value, chvalue) => {
                const values = this.state.editOptionValueModal.option.values
                const valueIndex = findIndex(values, ['key', this.state.editOptionValueModal.value.key])
                values[valueIndex] = { ...values[valueIndex], value, chvalue }
                onChange(product._id, {
                  options: set(
                    product.options,
                    [this.state.editOptionValueModal.option.key, "values"],
                    values
                  )
                })
                this.setState({ editOptionValueModal: false })
              }}
            />
          )
        }

        {
          this.state.addExtraModal && (
            <ModalNameEditor
              headerTitle="Añadir extra"
              onClose={() => this.setState({ addExtraModal: false })}
              onChange={(title, chTitle) => {
                const key = randstr()
                onChange(product._id,
                  {
                    extras: { ...product.extras,
                      [key]: { key,
                        title,
                        chTitle,
                        price: {
                          general: 0,
                          ageAware: false,
                          perGroup: false,
                          agePrices: [],
                        }, } }
                  })
                this.setState({ addExtraModal: false })
              }}
            />
          )
        }

        {
          this.state.editExtraModal && (
            <ModalNameEditor
              headerTitle="Editar extra"
              value={this.state.editExtraModal}
              onClose={() => this.setState({ editExtraModal: false })}
              onChange={(title, chTitle) => {
                onChange(product._id, {
                  extras: set(
                    product.extras,
                    [this.state.editExtraModal.key],
                    { ...product.extras[this.state.editExtraModal.key], title, chTitle }
                  )
                })
                this.setState({ editExtraModal: false })
              }}
            />
          )
        }
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  ready: getReadyState(state, props),
  tags: getProductTags(state, props)
})

const mapDispatchToProps = dispatch => ({
  onChange: (id, changes) => dispatch(updateProduct(id, changes)),
  onRemove: id => dispatch(removeProduct(id))
})

export default connect(
  mapStateToProps, mapDispatchToProps
)(Product)
